import { storageFeesSettingSchema } from "@redotech/redo-billing-common/warehouse-storage";
import { GradeMappingsSchema } from "@redotech/redo-return-settings-common/grade-mapping";
import { processingBillingConfigSchema } from "@redotech/redo-return-settings-common/processing-billing-config";
import {
  receivingOutcomeSchema,
  returnsCenterReceivingOutcomesSchema,
} from "@redotech/redo-return-settings-common/receiving-outcome-config";
import { remitModeSchema } from "@redotech/redo-return-settings-common/remit-mode-config";
import {
  returnProcessingLevelSchema,
  returnsCenterProcessingLevelsSchema,
} from "@redotech/redo-return-settings-common/return-processing-level";
import { ReturnsCenterGradeOverridesSchema } from "@redotech/redo-return-settings-common/returns-center-grade-overrides";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getManagedReturnsSettings = unaryRpc({
  name: "getManagedReturnsSettings" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    billing: processingBillingConfigSchema,
    storageFees: storageFeesSettingSchema.optional(),
    storageAssessmentSummary: z
      .object({
        billing_date: z.string(),
        status: z.string(),
        quantity: z.string(),
        excluded_quantity: z.string(),
        amount: z.string(),
        currency: z.string(),
      })
      .nullable()
      .optional(),
    returnProcessingLevel: returnProcessingLevelSchema,
    receivingOutcome: receivingOutcomeSchema.nullable(),
    gradeMappings: GradeMappingsSchema,
    remitMode: remitModeSchema,
    returnsCenterOverrides: z.array(ReturnsCenterGradeOverridesSchema),
    returnsCenterProcessingLevels: returnsCenterProcessingLevelsSchema,
    returnsCenterReceivingOutcomes: returnsCenterReceivingOutcomesSchema,
  }),
});
